import React from 'react';
import { 
  FaLinux, 
  FaUbuntu, 
  FaRedhat, 
  FaWindows,
  FaDocker,
  FaDatabase,
  FaServer,
  FaCloud,
  FaGlobe,
  FaCog,
  FaHdd
} from 'react-icons/fa';
import { 
  SiDebian, 
  SiOpensuse, 
  SiKubernetes, 
  SiMysql, 
  SiPostgresql, 
  SiRedis, 
  SiMongodb,
  SiPodman,
  SiWordpress,
  SiJoomla,
  SiDrupal
} from 'react-icons/si';

// Operating System Icons
export const OSIcon = ({ os, className = "w-8 h-8" }) => {
  const icons = {
    debian: <SiDebian className={`${className} text-red-600`} />,
    ubuntu: <FaUbuntu className={`${className} text-orange-500`} />,
    fedora: <FaRedhat className={`${className} text-blue-600`} />,
    centos: <FaRedhat className={`${className} text-purple-600`} />,
    opensuse: <SiOpensuse className={`${className} text-green-600`} />,
    windows: <FaWindows className={`${className} text-blue-500`} />,
    windows2022: <FaWindows className={`${className} text-blue-500`} />,
    windows2019: <FaWindows className={`${className} text-blue-500`} />,
    windows2016: <FaWindows className={`${className} text-blue-500`} />,
    linux: <FaLinux className={`${className} text-gray-700`} />
  };
  
  return icons[os] || <FaServer className={`${className} text-gray-500`} />;
};

// Database Icons
export const DatabaseIcon = ({ database, className = "w-8 h-8" }) => {
  const icons = {
    mysql: <SiMysql className={`${className} text-blue-600`} />,
    postgresql: <SiPostgresql className={`${className} text-blue-700`} />,
    redis: <SiRedis className={`${className} text-red-600`} />,
    mongodb: <SiMongodb className={`${className} text-green-600`} />
  };
  
  return icons[database] || <FaDatabase className={`${className} text-gray-500`} />;
};

// Orchestrator Icons
export const OrchestratorIcon = ({ type, className = "w-8 h-8" }) => {
  const icons = {
    'k8s-mono': <SiKubernetes className={`${className} text-blue-600`} />,
    kubernetes: <SiKubernetes className={`${className} text-blue-600`} />,
    docker: <FaDocker className={`${className} text-blue-500`} />,
    podman: <SiPodman className={`${className} text-purple-600`} />
  };
  
  return icons[type] || <FaCog className={`${className} text-gray-500`} />;
};

// Service Icons
export const ServiceIcon = ({ service, className = "w-12 h-12" }) => {
  const icons = {
    cloudVPS: <FaCloud className={`${className} text-primary`} />,
    orchestrator: <SiKubernetes className={`${className} text-secondary`} />,
    dbaas: <FaDatabase className={`${className} text-green-600`} />,
    domains: <FaGlobe className={`${className} text-purple-600`} />,
    cmsaas: <SiWordpress className={`${className} text-blue-600`} />,
    dedicatedServer: <FaServer className={`${className} text-red-600`} />
  };
  
  return icons[service] || <FaServer className={`${className} text-gray-500`} />;
};

// CMS Icons
export const CMSIcon = ({ cms, className = "w-8 h-8" }) => {
  const icons = {
    wordpress: <SiWordpress className={`${className} text-blue-600`} />,
    joomla: <SiJoomla className={`${className} text-orange-600`} />,
    drupal: <SiDrupal className={`${className} text-blue-700`} />
  };
  
  return icons[cms] || <FaCog className={`${className} text-gray-500`} />;
};

// Configuration Icons
export const ConfigIcon = ({ config, className = "w-6 h-6" }) => {
  const icons = {
    standard: <FaHdd className={`${className} text-gray-600`} />,
    silver: <FaHdd className={`${className} text-gray-400`} />,
    gold: <FaHdd className={`${className} text-yellow-500`} />,
    platinum: <FaHdd className={`${className} text-purple-600`} />,
    dedihostm1: <FaServer className={`${className} text-blue-600`} />,
    dedihostm2: <FaServer className={`${className} text-green-600`} />,
    dedihosts3: <FaServer className={`${className} text-orange-600`} />,
    dedihosts4: <FaServer className={`${className} text-red-600`} />
  };
  
  return icons[config] || <FaServer className={`${className} text-gray-500`} />;
};
